import React from 'react';
import styled from "styled-components";
import {Column, Row} from "../styled-components/layout";
import {borderColor, warning} from "../colors";
import WarningIcon from "../icons/Warning";
import {ListItem} from "../styled-components/typography";

interface WarningProps {
    messages: (string | React.ReactNode)[]
}
const Warning = ({messages}: WarningProps) => {
    return (
        <WarningContainer>
            <WarningBox><WarningIcon color={'white'} /></WarningBox>
            <WarningTextBox>
                <WarningList>
                    {
                        messages.map((message, index) => (
                            <WarningText key={`restriction-${index}`}>{message}</WarningText>
                        ))
                    }
                </WarningList>
            </WarningTextBox>
        </WarningContainer>
    )
};

const WarningContainer = styled(Row)`
  justify-content: flex-start;
  border: 1px solid ${borderColor};
`;

const WarningBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${warning};
  padding: 15px;
`;

const WarningTextBox = styled(Column)`
  padding: 22px;
  justify-content: center;
`;

const WarningList = styled.ul`
  margin: 0;
  padding-left: 22px;
`;

const WarningText = styled(ListItem)`
  margin: 2px 0;
`;

export default Warning;
